// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"21436":"0a31c19d","50666":"349c78e2","64787":"466454fc"}[chunkId] + ".chunk.css";
};